module.exports = __webpack_public_path__ + "img/delete.80fbd0a3.svg";